import React, { useEffect, useState } from 'react';
import { AdminLayout } from '../../components/AdminLayout';
import axiosInstance from '../../lib/axios';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Users, Search } from 'lucide-react';
import { toast } from 'sonner';

export default function PatientsManagement() {
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPatients();
  }, []);

  const fetchPatients = async () => {
    try {
      const res = await axiosInstance.get('/patients');
      setPatients(res.data);
    } catch (error) {
      toast.error('Failed to load patients');
    } finally {
      setLoading(false);
    }
  };

  const filteredPatients = patients.filter(p => 
    p.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AdminLayout>
      <div className="p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-manrope font-bold mb-2" data-testid="patients-title">
            Patients Management
          </h1>
          <p className="text-slate-600">View and manage patient records</p>
        </div>

        <div className="mb-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input
              placeholder="Search patients by name or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          </div>
        ) : (
          <div className="grid gap-4">
            {filteredPatients.map((patient, index) => (
              <Card key={index}>
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                      <Users className="h-6 w-6 text-primary" />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-lg">{patient.full_name}</h3>
                      <div className="flex items-center gap-4 mt-1 text-sm text-slate-600">
                        <span>{patient.email}</span>
                        <span>{patient.phone}</span>
                      </div>
                      <div className="mt-2 text-xs text-slate-500">
                        Registered: {new Date(patient.created_at).toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
            {filteredPatients.length === 0 && (
              <Card>
                <CardContent className="pt-6 text-center text-slate-500">
                  {searchTerm ? 'No patients found matching your search.' : 'No patients registered yet.'}
                </CardContent>
              </Card>
            )}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}